import FreeFormTexts from './FreeFormTexts';

export default FreeFormTexts;
